module.exports = __webpack_public_path__ + "img/chevron_left.eb78e0da.svg";